export const dumpPopularValuesToQuery = ({ key, values }) =>
  values.reduce((acc, value, index) => acc.concat(`${key}:"${value}" ${index === values.length - 1 ? '' : 'OR '}`), '');
